import { MergedObservable, } from "./MergedObservable.js";
/**
 * Merges multiple observables into a single observable.
 *
 * @beta
 */
export function mergeObservables(...observables) {
    return new MergedObservable(...observables).beacon;
}
